<template>
  <div class="article-Content">
    <template v-if="artContent.contentType === 0">
      <div
        v-if="showTitle"
        class="artTitle"
      >
        {{ artContent.title }}
      </div>
      <div
        v-if="showTitle"
        class="art-date-hits"
      >
        <span>发布日期：{{ artContent.createTime.split(' ')[0] }}</span>
        <span class="hits">点击量：{{ artContent.hits }}</span>
      </div>
      <div
        :class="['art-content', !showTitle && 'un-title', from == 'home' && 'fromHome']"
        v-html="artContent.content"
      />
    </template>
    <template v-else-if="artContent.contentType === 1">
      <iframe
        id="article-Content-iframe"
        :src="artContent.contentLink"
        frameborder="0"
        marginwidth="0"
        marginheight="0"
        allow="*"
      />
    </template>
    <template v-else-if="artContent.contentType === 2">
      <video
        class="article-Content-video"
        :src="artContent.contentVideo"
        :poster="artContent.contentVideoImage || ''"
        controls
      />
    </template>
  </div>
</template>

<script>
export default {
    name: 'ArticleContent',
    props: {
        artContent: {
            type: Object,
            default: () => {
                return {
                    contentType: '', // 0 contentText; 1 link; 2 video;
                    content: '',
                    title: '',
                    createTime: '',
                    hits: 0,
                    contentLink: '',
                    contentVideo: '',
                    contentVideoImage: '',
                    videoName: '',
                };
            },
        },
        showTitle: {
            type: Boolean,
            default: false,
        },
        from: {
            type: String,
            default: '',
        },
    },
};
</script>

<style scoped lang="scss">
@import "../style.scss";
.article-Content {
    width: 100%;
    position: relative;
    .artTitle {
        width: 100%;
        text-align: center;
        color: #464C5B;
        font-size: 32px;
        line-height: 45px;
        margin: 15px 0;
        margin-top: 20px;
        box-sizing: border-box;
    }
    .art-date-hits {
        font-size: 14px;
        color: #9EA7B4;
        text-align: center;
        margin-bottom: 30px;
        .hits {
            margin-left: 10px;
        }
    }
    .art-content {
        margin-top: 40px;
        &.un-title {
            margin-top: 30px;
        }
        &.fromHome {
            margin-top: 0;
        }
    }
    #article-Content-iframe {
        display: block;
        position: relative;
        width: $pageWidth + 90;
        left: -45px;
        height: calc(100vh - 200px);
        box-sizing: border-box;
        margin-top: 20px;
    }
    .article-Content-video {
        margin-top: 20px;
        width: 1100px;
        height: 650px;
        object-fit: cover;
        position: relative;
        top: 50%;
        left: 50%;
        transform: translate(-50%, 0%);
    }
}
</style>
